import { create, StateCreator } from "zustand";
import { TransactionSocketHandler } from "@/services/transaction-socket-handler";
import { devtools } from "zustand/middleware";
import getTransactionSocket from "@/services/transaction-socket-handler/getTransactionSocket";

export interface TransactionSocketState {
  socketHandler: TransactionSocketHandler;
  setSocketHandler: (socketHandler: TransactionSocketHandler) => void;
}

const initialStateCreator: StateCreator<TransactionSocketState, any> = (set) => ({
  socketHandler: getTransactionSocket(),
  setSocketHandler: (socketHandler) => {
    set({ socketHandler });
  },
});

const useTransactionSocketStore = create(devtools(initialStateCreator));

export default useTransactionSocketStore;
